// Geräte-Finder (22.10.2026) – Erklärung in sections/rxk-geraete-finder.liquid.
// Drei Wege zum Modell: Modellnummer (A-Nummer), Einstellungen (Modellname wählen), Aussehen (Fragen).
// Ergebnis merkt das Gerät wie „Meine Geräte“ (assets/rxk-geraete.js, gleicher localStorage-Schlüssel).
(() => {
  // ---------- Gerätedatenbank ----------
  // n = Name wie in der Option „Modell“ der Produkte, j = Jahr, a = Modellnummern (Apple),
  // nv = nicht im Sortiment (nur Erkennung). iPhone-Merkmale fürs Aussehen:
  // k Kamera (single|dualdiag|dualvert|triple|band1|band3|duo), o oben (notch|di), p Anschluss (l|c),
  // cc Kamera-Taste (0|1), b Breite (mini|mittel|gross|air), f Farben (nur wo nötig).
  const IPHONE = [
    { n: 'iPhone SE (2020)', j: 2020, a: ['A2275', 'A2296', 'A2298'], nv: 1 },
    { n: 'iPhone SE (2022)', j: 2022, a: ['A2595', 'A2782', 'A2783', 'A2784', 'A2785'], nv: 1 },
    { n: 'iPhone 11', j: 2019, a: ['A2111', 'A2221', 'A2223'], nv: 1 },
    { n: 'iPhone 11 Pro', j: 2019, a: ['A2160', 'A2217', 'A2215'], nv: 1 },
    { n: 'iPhone 11 Pro Max', j: 2019, a: ['A2161', 'A2220', 'A2218'], nv: 1 },
    { n: 'iPhone 12 Mini', j: 2020, a: ['A2176', 'A2398', 'A2399', 'A2400'], nv: 1, k: 'dualvert', o: 'notch', p: 'l', cc: 0, b: 'mini' },
    { n: 'iPhone 12', j: 2020, a: ['A2172', 'A2402', 'A2403', 'A2404'], nv: 1, k: 'dualvert', o: 'notch', p: 'l', cc: 0, b: 'mittel' },
    { n: 'iPhone 12 Pro', j: 2020, a: ['A2341', 'A2406', 'A2407', 'A2408'], nv: 1, k: 'triple', o: 'notch', p: 'l', cc: 0, b: 'mittel', f: ['graphit', 'silber', 'gold', 'pazifikblau'] },
    { n: 'iPhone 12 Pro Max', j: 2020, a: ['A2342', 'A2410', 'A2411', 'A2412'], nv: 1, k: 'triple', o: 'notch', p: 'l', cc: 0, b: 'gross', f: ['graphit', 'silber', 'gold', 'pazifikblau'] },
    { n: 'iPhone 13 Mini', j: 2021, a: ['A2481', 'A2626', 'A2629', 'A2630', 'A2628'], k: 'dualdiag', o: 'notch', p: 'l', cc: 0, b: 'mini', f: ['rot', 'polarstern', 'mitternacht', 'blau', 'rosa', 'gruen'] },
    { n: 'iPhone 13', j: 2021, a: ['A2482', 'A2631', 'A2634', 'A2635', 'A2633'], k: 'dualdiag', o: 'notch', p: 'l', cc: 0, b: 'mittel', f: ['rot', 'polarstern', 'mitternacht', 'blau', 'rosa', 'gruen'] },
    { n: 'iPhone 13 Pro', j: 2021, a: ['A2483', 'A2636', 'A2639', 'A2640', 'A2638'], k: 'triple', o: 'notch', p: 'l', cc: 0, b: 'mittel', f: ['graphit', 'silber', 'gold', 'sierrablau', 'alpengruen'] },
    { n: 'iPhone 13 Pro Max', j: 2021, a: ['A2484', 'A2641', 'A2644', 'A2645', 'A2643'], k: 'triple', o: 'notch', p: 'l', cc: 0, b: 'gross', f: ['graphit', 'silber', 'gold', 'sierrablau', 'alpengruen'] },
    { n: 'iPhone 14', j: 2022, a: ['A2649', 'A2881', 'A2884', 'A2883', 'A2882'], k: 'dualdiag', o: 'notch', p: 'l', cc: 0, b: 'mittel', f: ['mitternacht', 'polarstern', 'rot', 'blau', 'lila', 'gelb'] },
    { n: 'iPhone 14 Plus', j: 2022, a: ['A2632', 'A2885', 'A2888', 'A2887', 'A2886'], k: 'dualdiag', o: 'notch', p: 'l', cc: 0, b: 'gross', f: ['mitternacht', 'polarstern', 'rot', 'blau', 'lila', 'gelb'] },
    { n: 'iPhone 14 Pro', j: 2022, a: ['A2650', 'A2889', 'A2892', 'A2891', 'A2890'], k: 'triple', o: 'di', p: 'l', cc: 0, b: 'mittel' },
    { n: 'iPhone 14 Pro Max', j: 2022, a: ['A2651', 'A2893', 'A2896', 'A2895', 'A2894'], k: 'triple', o: 'di', p: 'l', cc: 0, b: 'gross' },
    { n: 'iPhone 15', j: 2023, a: ['A2846', 'A3089', 'A3092', 'A3090'], k: 'dualdiag', o: 'di', p: 'c', cc: 0, b: 'mittel' },
    { n: 'iPhone 15 Plus', j: 2023, a: ['A2847', 'A3093', 'A3096', 'A3094'], k: 'dualdiag', o: 'di', p: 'c', cc: 0, b: 'gross' },
    { n: 'iPhone 15 Pro', j: 2023, a: ['A2848', 'A3101', 'A3104', 'A3102'], k: 'triple', o: 'di', p: 'c', cc: 0, b: 'mittel' },
    { n: 'iPhone 15 Pro Max', j: 2023, a: ['A2849', 'A3105', 'A3108', 'A3106'], k: 'triple', o: 'di', p: 'c', cc: 0, b: 'gross' },
    { n: 'iPhone 16', j: 2024, a: ['A3081', 'A3286', 'A3288', 'A3287'], k: 'dualvert', o: 'di', p: 'c', cc: 1, b: 'mittel', f: ['schwarz', 'weiss', 'rosa', 'tuerkis', 'ultramarin'] },
    { n: 'iPhone 16 Plus', j: 2024, a: ['A3082', 'A3289', 'A3291', 'A3290'], k: 'dualvert', o: 'di', p: 'c', cc: 1, b: 'gross' },
    { n: 'iPhone 16 Pro', j: 2024, a: ['A3083', 'A3292', 'A3294', 'A3293'], k: 'triple', o: 'di', p: 'c', cc: 1, b: 'mittel' },
    { n: 'iPhone 16 Pro Max', j: 2024, a: ['A3084', 'A3295', 'A3297', 'A3296'], k: 'triple', o: 'di', p: 'c', cc: 1, b: 'gross' },
    { n: 'iPhone 16e', j: 2025, a: ['A3212', 'A3408', 'A3410', 'A3409'], k: 'single', o: 'notch', p: 'c', cc: 0, b: 'mittel', f: ['schwarz', 'weiss'] },
    { n: 'iPhone 17', j: 2025, a: ['A3258', 'A3519', 'A3521', 'A3520'], k: 'dualvert', o: 'di', p: 'c', cc: 1, b: 'mittel', f: ['schwarz', 'weiss', 'nebelblau', 'salbei', 'lavendel'] },
    { n: 'iPhone 17 Pro', j: 2025, a: ['A3256', 'A3522', 'A3524', 'A3523'], k: 'band3', o: 'di', p: 'c', cc: 1, b: 'mittel', f: ['silber', 'orange', 'dunkelblau'] },
    { n: 'iPhone 17 Pro Max', j: 2025, a: ['A3257', 'A3525', 'A3527', 'A3526'], k: 'band3', o: 'di', p: 'c', cc: 1, b: 'gross', f: ['silber', 'orange', 'dunkelblau'] },
    { n: 'iPhone Air', j: 2025, a: ['A3260', 'A3516', 'A3518', 'A3517'], k: 'band1', o: 'di', p: 'c', cc: 1, b: 'air' },
    { n: 'iPhone 17e', j: 2026, a: ['A3575', 'A3635', 'A3634'], k: 'single', o: 'notch', p: 'c', cc: 0, b: 'mittel', f: ['schwarz', 'weiss', 'rosa'] },
    { n: 'iPhone 18 Pro', j: 2026, a: ['A3472', 'A3713', 'A3715', 'A3714'], k: 'band3', o: 'di', p: 'c', cc: 1, b: 'mittel', f: ['schwarz', 'silber', 'gletscher', 'burgund'] },
    { n: 'iPhone 18 Pro Max', j: 2026, a: ['A3473', 'A3716', 'A3718', 'A3717'], k: 'band3', o: 'di', p: 'c', cc: 1, b: 'gross', f: ['schwarz', 'silber', 'gletscher', 'burgund'] },
    { n: 'iPhone Duo', j: 2026, a: [], k: 'duo' },
  ];
  // MacBook: t Air|Pro, z Zoll, c Chip-Zeile aus „Über diesen Mac“ (Auswahl im Weg 2)
  const MAC = [
    // MacBook Neo (2026, A18 Pro) – A-Nummer aus Apple Wiki, Apple selbst nennt keine; Skins seit 22.10. im Shop
    { n: 'MacBook Neo 13" (A18 Pro)', j: 2026, a: ['A3404'], t: 'Neo', z: 13, c: 'A18 Pro' },
    // Intel-Generationen (Skins seit 22.10. im Shop). Air 2018–2020 hat denselben Deckel wie Air M1, Pro 13" 2016–2020 wie Pro 13" M1/M2
    { n: 'MacBook Air 13" (2017)', j: 2017, a: ['A1466'], t: 'Air', z: 13, c: 'Intel' },
    { n: 'MacBook Air 13" (2018)', j: 2018, a: ['A1932'], t: 'Air', z: 13, c: 'Intel' },
    { n: 'MacBook Air 13" (2019)', j: 2019, a: ['A1932'], t: 'Air', z: 13, c: 'Intel' },
    { n: 'MacBook Air 13" (2020)', j: 2020, a: ['A2179'], t: 'Air', z: 13, c: 'Intel' },
    { n: 'MacBook Pro 13" (2016)', j: 2016, a: ['A1706', 'A1708'], t: 'Pro', z: 13, c: 'Intel' },
    { n: 'MacBook Pro 13" (2017)', j: 2017, a: ['A1706', 'A1708'], t: 'Pro', z: 13, c: 'Intel' },
    { n: 'MacBook Pro 13" (2018)', j: 2018, a: ['A1989'], t: 'Pro', z: 13, c: 'Intel' },
    { n: 'MacBook Pro 13" (2019)', j: 2019, a: ['A1989', 'A2159'], t: 'Pro', z: 13, c: 'Intel' },
    { n: 'MacBook Pro 13" (2020)', j: 2020, a: ['A2251', 'A2289'], t: 'Pro', z: 13, c: 'Intel' },
    { n: 'MacBook Pro 15" (2016)', j: 2016, a: ['A1707'], t: 'Pro', z: 15, c: 'Intel' },
    { n: 'MacBook Pro 15" (2017)', j: 2017, a: ['A1707'], t: 'Pro', z: 15, c: 'Intel' },
    { n: 'MacBook Pro 15" (2018)', j: 2018, a: ['A1990'], t: 'Pro', z: 15, c: 'Intel' },
    { n: 'MacBook Pro 15" (2019)', j: 2019, a: ['A1990'], t: 'Pro', z: 15, c: 'Intel' },
    { n: 'MacBook Pro 16" (2019)', j: 2019, a: ['A2141'], t: 'Pro', z: 16, c: 'Intel' },
    { n: 'MacBook Air 13" (M1)', j: 2020, a: ['A2337'], t: 'Air', z: 13, c: 'M1' },
    { n: 'MacBook Air 13" (M2)', j: 2022, a: ['A2681'], t: 'Air', z: 13, c: 'M2' },
    { n: 'MacBook Air 15" (M2)', j: 2023, a: ['A2941'], t: 'Air', z: 15, c: 'M2' },
    { n: 'MacBook Air 13" (M3)', j: 2024, a: ['A3113'], t: 'Air', z: 13, c: 'M3' },
    { n: 'MacBook Air 15" (M3)', j: 2024, a: ['A3114'], t: 'Air', z: 15, c: 'M3' },
    { n: 'MacBook Air 13" (M4)', j: 2025, a: ['A3240'], t: 'Air', z: 13, c: 'M4' },
    { n: 'MacBook Air 15" (M4)', j: 2025, a: ['A3241'], t: 'Air', z: 15, c: 'M4' },
    { n: 'MacBook Air 13" (M5)', j: 2026, a: ['A3449'], t: 'Air', z: 13, c: 'M5' },
    { n: 'MacBook Air 15" (M5)', j: 2026, a: ['A3448'], t: 'Air', z: 15, c: 'M5' },
    { n: 'MacBook Pro 13" (M1)', j: 2020, a: ['A2338'], t: 'Pro', z: 13, c: 'M1' },
    { n: 'MacBook Pro 13" (M2)', j: 2022, a: ['A2338'], t: 'Pro', z: 13, c: 'M2' },
    { n: 'MacBook Pro 14" (M1 Pro/Max)', j: 2021, a: ['A2442'], t: 'Pro', z: 14, c: 'M1 Pro / M1 Max' },
    { n: 'MacBook Pro 16" (M1 Pro/Max)', j: 2021, a: ['A2485'], t: 'Pro', z: 16, c: 'M1 Pro / M1 Max' },
    { n: 'MacBook Pro 14" (M2 Pro/Max)', j: 2023, a: ['A2779'], t: 'Pro', z: 14, c: 'M2 Pro / M2 Max' },
    { n: 'MacBook Pro 16" (M2 Pro/Max)', j: 2023, a: ['A2780'], t: 'Pro', z: 16, c: 'M2 Pro / M2 Max' },
    { n: 'MacBook Pro 14" (M3)', j: 2023, a: ['A2918'], t: 'Pro', z: 14, c: 'M3' },
    { n: 'MacBook Pro 14" (M3 Pro/Max)', j: 2023, a: ['A2992'], t: 'Pro', z: 14, c: 'M3 Pro / M3 Max' },
    { n: 'MacBook Pro 16" (M3 Pro/Max)', j: 2023, a: ['A2991'], t: 'Pro', z: 16, c: 'M3 Pro / M3 Max' },
    { n: 'MacBook Pro 14" (M4)', j: 2024, a: ['A3112'], t: 'Pro', z: 14, c: 'M4' },
    { n: 'MacBook Pro 14" (M4 Pro/Max)', j: 2024, a: ['A3185'], t: 'Pro', z: 14, c: 'M4 Pro / M4 Max' },
    { n: 'MacBook Pro 16" (M4 Pro/Max)', j: 2024, a: ['A3186'], t: 'Pro', z: 16, c: 'M4 Pro / M4 Max' },
    { n: 'MacBook Pro 14" (M5)', j: 2025, a: ['A3434'], t: 'Pro', z: 14, c: 'M5' },
    { n: 'MacBook Pro 14" (M5 Pro/Max)', j: 2026, a: [], t: 'Pro', z: 14, c: 'M5 Pro / M5 Max' },
    { n: 'MacBook Pro 16" (M5 Pro/Max)', j: 2026, a: [], t: 'Pro', z: 16, c: 'M5 Pro / M5 Max' },
    { n: 'MacBook Pro 14" (M6)', j: 2026, a: ['A3536'], t: 'Pro', z: 14, c: 'M6' },
  ];
  // iPad: t Familie (iPad|Air|mini|Pro), e = Name laut Einstellungen (Modellname), wenn er vom Shopnamen abweicht
  const IPAD = [
    { n: 'iPad 7th Gen', j: 2019, a: ['A2197', 'A2200', 'A2198'], t: 'iPad', nv: 1, e: 'iPad (7. Generation)' },
    { n: 'iPad 8th Gen', j: 2020, a: ['A2270', 'A2428', 'A2429', 'A2430'], t: 'iPad', nv: 1, e: 'iPad (8. Generation)' },
    { n: 'iPad 9th Gen', j: 2021, a: ['A2602', 'A2604', 'A2603', 'A2605'], t: 'iPad', e: 'iPad (9. Generation)' },
    { n: 'iPad 10th Gen', j: 2022, a: ['A2696', 'A2757', 'A2777', 'A3162'], t: 'iPad', e: 'iPad (10. Generation)' },
    { n: 'iPad 11th Gen', j: 2025, a: ['A3354', 'A3355', 'A3356'], t: 'iPad', e: 'iPad (A16)' },
    { n: 'iPad mini 5', j: 2019, a: ['A2133', 'A2124', 'A2126', 'A2125'], t: 'mini', e: 'iPad mini (5. Generation)' },
    { n: 'iPad mini 6', j: 2021, a: ['A2567', 'A2568', 'A2569'], t: 'mini', e: 'iPad mini (6. Generation)' },
    { n: 'iPad mini 7', j: 2024, a: ['A2993', 'A2995', 'A2996'], t: 'mini', e: 'iPad mini (A17 Pro)' },
    { n: 'iPad mini 8', j: 2026, a: ['A3596', 'A3597'], t: 'mini', e: 'iPad mini (A20 Pro)' },
    { n: 'iPad Air 3', j: 2019, a: ['A2152', 'A2123', 'A2153', 'A2154'], t: 'Air', nv: 1, e: 'iPad Air (3. Generation)' },
    { n: 'iPad Air 4', j: 2020, a: ['A2316', 'A2324', 'A2325', 'A2072'], t: 'Air', e: 'iPad Air (4. Generation)' },
    { n: 'iPad Air 5', j: 2022, a: ['A2588', 'A2589', 'A2591'], t: 'Air', e: 'iPad Air (5. Generation)' },
    { n: 'iPad Air 11" (M2)', j: 2024, a: ['A2902', 'A2903', 'A2904'], t: 'Air' },
    { n: 'iPad Air 13" (M2)', j: 2024, a: ['A2898', 'A2899', 'A2900'], t: 'Air' },
    { n: 'iPad Air 11" (M3)', j: 2025, a: ['A3266', 'A3267', 'A3270'], t: 'Air' },
    { n: 'iPad Air 13" (M3)', j: 2025, a: ['A3268', 'A3269', 'A3271'], t: 'Air' },
    { n: 'iPad Air 11" (M4)', j: 2026, a: ['A3459', 'A3460', 'A3463'], t: 'Air' },
    { n: 'iPad Air 13" (M4)', j: 2026, a: ['A3461', 'A3462', 'A3464'], t: 'Air' },
    { n: 'iPad Pro 11" (2020)', j: 2020, a: ['A2228', 'A2068', 'A2230', 'A2231'], t: 'Pro', nv: 1, e: 'iPad Pro 11" (2. Generation)' },
    { n: 'iPad Pro 12.9" (2020)', j: 2020, a: ['A2229', 'A2069', 'A2232', 'A2233'], t: 'Pro', nv: 1, e: 'iPad Pro 12,9" (4. Generation)' },
    { n: 'iPad Pro 11" (2021)', j: 2021, a: ['A2377', 'A2459', 'A2301', 'A2460'], t: 'Pro', e: 'iPad Pro 11" (3. Generation)' },
    { n: 'iPad Pro 12.9" (2021)', j: 2021, a: ['A2378', 'A2461', 'A2379', 'A2462'], t: 'Pro', e: 'iPad Pro 12,9" (5. Generation)' },
    { n: 'iPad Pro 11" (2022)', j: 2022, a: ['A2759', 'A2761', 'A2435', 'A2762'], t: 'Pro', e: 'iPad Pro 11" (4. Generation)' },
    { n: 'iPad Pro 12.9" (2022)', j: 2022, a: ['A2436', 'A2437', 'A2764', 'A2766'], t: 'Pro', e: 'iPad Pro 12,9" (6. Generation)' },
    { n: 'iPad Pro 11" (M4)', j: 2024, a: ['A2836', 'A2837', 'A3006'], t: 'Pro' },
    { n: 'iPad Pro 13" (M4)', j: 2024, a: ['A2925', 'A2926', 'A3007'], t: 'Pro' },
    { n: 'iPad Pro 11" (M5)', j: 2025, a: ['A3357', 'A3358', 'A3359'], t: 'Pro' },
    { n: 'iPad Pro 13" (M5)', j: 2025, a: ['A3360', 'A3361', 'A3362'], t: 'Pro' },
  ];
  // iMac 24" (28.10.2026): seit 2021 dasselbe Gehäuse (M1, M3, M4, M6); Skin-Ausschnitt hängt an 2 oder 4 USB-C-Buchsen hinten.
  // c Chip, u Anschlüsse. A-Nummern: M1 A2439/A2438, M3 A2874/A2873 (EveryMac), M4 A3247/A3137 (Apple Wiki, Energy Star), M6 noch unbekannt
  const IMAC = [
    { n: 'iMac 24" (M6) · 4 × USB-C', j: 2026, a: [], c: 'M6', u: 4 },
    { n: 'iMac 24" (M6) · 2 × USB-C', j: 2026, a: [], c: 'M6', u: 2 },
    { n: 'iMac 24" (M4) · 4 × USB-C', j: 2024, a: ['A3137'], c: 'M4', u: 4 },
    { n: 'iMac 24" (M4) · 2 × USB-C', j: 2024, a: ['A3247'], c: 'M4', u: 2 },
    { n: 'iMac 24" (M3) · 4 × USB-C', j: 2023, a: ['A2873'], c: 'M3', u: 4 },
    { n: 'iMac 24" (M3) · 2 × USB-C', j: 2023, a: ['A2874'], c: 'M3', u: 2 },
    { n: 'iMac 24" (M1) · 4 × USB-C', j: 2021, a: ['A2438'], c: 'M1', u: 4 },
    { n: 'iMac 24" (M1) · 2 × USB-C', j: 2021, a: ['A2439'], c: 'M1', u: 2 },
  ];
  const ALLE = [...IPHONE.map((d) => ({ ...d, g: 'iphone' })), ...MAC.map((d) => ({ ...d, g: 'mac' })), ...IPAD.map((d) => ({ ...d, g: 'ipad' })), ...IMAC.map((d) => ({ ...d, g: 'imac' }))];

  // Bildschirm in CSS-Pixeln (hochkant) -> mögliche iPhones (Kopie aus rxk-geraete.js)
  const BILDSCHIRM = {
    '440x956': ['iPhone 18 Pro Max', 'iPhone 17 Pro Max', 'iPhone 16 Pro Max'],
    '402x874': ['iPhone 18 Pro', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16 Pro'],
    '420x912': ['iPhone Air'],
    '430x932': ['iPhone 16 Plus', 'iPhone 15 Pro Max', 'iPhone 15 Plus', 'iPhone 14 Pro Max'],
    '393x852': ['iPhone 16', 'iPhone 15 Pro', 'iPhone 15', 'iPhone 14 Pro'],
    '390x844': ['iPhone 17e', 'iPhone 16e', 'iPhone 14', 'iPhone 13 Pro', 'iPhone 13'],
    '428x926': ['iPhone 14 Plus', 'iPhone 13 Pro Max'],
    '375x812': ['iPhone 13 Mini'],
  };

  // Fragen zum Aussehen (nur iPhone), in dieser Reihenfolge; gestellt nur, wenn sie noch trennen.
  const FRAGEN = [
    { a: 'k', werte: ['single', 'dualdiag', 'dualvert', 'triple', 'band1', 'band3', 'duo'] },
    { a: 'o', werte: ['notch', 'di'] },
    { a: 'p', werte: ['l', 'c'] },
    { a: 'cc', werte: [1, 0] },
    { a: 'b', werte: ['mini', 'mittel', 'gross', 'air'] },
    { a: 'f', werte: ['schwarz', 'weiss', 'silber', 'gold', 'graphit', 'rosa', 'tuerkis', 'ultramarin', 'nebelblau', 'salbei', 'lavendel', 'orange', 'dunkelblau', 'gletscher', 'burgund', 'pazifikblau', 'sierrablau', 'alpengruen', 'rot', 'polarstern', 'mitternacht', 'blau', 'gruen', 'lila', 'gelb'] },
  ];

  // ---------- Zeichnungen ----------
  const svg = (inhalt, vb = '0 0 60 100') => `<svg viewBox="${vb}" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">${inhalt}</svg>`;
  const handy = '<rect x="4" y="3" width="52" height="94" rx="9"/>';
  const linse = (x, y, r = 5) => `<circle cx="${x}" cy="${y}" r="${r}"/><circle cx="${x}" cy="${y}" r="${r * 0.45}"/>`;
  const BILD = {
    k_single: svg(handy + '<rect x="10" y="9" width="16" height="16" rx="5"/>' + linse(18, 17, 4.5)),
    k_dualdiag: svg(handy + '<rect x="9" y="8" width="24" height="24" rx="7"/>' + linse(15.5, 14.5, 4) + linse(26.5, 25.5, 4)),
    k_dualvert: svg(handy + '<rect x="9" y="8" width="16" height="28" rx="7"/>' + linse(17, 15, 4) + linse(17, 29, 4)),
    k_triple: svg(handy + '<rect x="9" y="8" width="26" height="26" rx="8"/>' + linse(16, 15, 4) + linse(28, 15, 4) + linse(16, 27, 4) + '<circle cx="28.5" cy="27" r="1.4"/>'),
    k_band1: svg(handy + '<rect x="8" y="8" width="44" height="16" rx="8"/>' + linse(17, 16, 4.5)),
    k_band3: svg(handy + '<rect x="8" y="8" width="44" height="22" rx="9"/>' + linse(16, 15, 4) + linse(28, 15, 4) + linse(16, 25, 4) + '<circle cx="44" cy="15" r="1.5"/>'),
    k_duo: svg('<rect x="4" y="3" width="38" height="94" rx="7"/><rect x="42" y="3" width="38" height="94" rx="7"/><line x1="42" y1="3" x2="42" y2="97" stroke-dasharray="3 3"/>' + linse(14, 15, 4) + linse(14, 28, 4), '0 0 84 100'),
    k_aelter: svg(handy + '<path d="M22 46h16M30 38v16" opacity=".5"/>'),
    o_notch: svg(handy + '<path d="M18 3v4a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V3"/>'),
    o_di: svg(handy + '<rect x="21" y="8" width="18" height="6" rx="3" fill="currentColor"/>'),
    p_l: svg('<rect x="4" y="3" width="52" height="94" rx="9"/><rect x="21" y="90" width="18" height="3.5" rx="1"/><path d="M23 90v3.5M26 90v3.5M29 90v3.5M32 90v3.5M35 90v3.5M38 90v3.5" opacity=".6"/>'),
    p_c: svg('<rect x="4" y="3" width="52" height="94" rx="9"/><rect x="20" y="89" width="20" height="5" rx="2.5"/>'),
    cc_1: svg(handy + '<rect x="56" y="62" width="2.5" height="14" rx="1" fill="currentColor"/><rect x="56" y="38" width="2.5" height="10" rx="1"/>'),
    cc_0: svg(handy + '<rect x="56" y="38" width="2.5" height="10" rx="1"/>'),
    b_mini: svg('<rect x="12" y="10" width="36" height="80" rx="7"/>'),
    b_mittel: svg('<rect x="8" y="6" width="44" height="88" rx="8"/>'),
    b_gross: svg('<rect x="4" y="2" width="52" height="96" rx="9"/>'),
    b_air: svg('<rect x="6" y="4" width="48" height="92" rx="8"/>'),
    typ_iphone: svg(handy + '<rect x="9" y="8" width="16" height="28" rx="7"/>' + linse(17, 15, 4) + linse(17, 29, 4)),
    typ_mac: svg('<rect x="10" y="22" width="80" height="50" rx="4"/><path d="M2 76h96v3a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4z"/><path d="M40 76h20"/>', '0 0 100 100'),
    typ_imac: svg('<rect x="4" y="12" width="92" height="62" rx="3"/><path d="M4 64h92"/><path d="M44 74l-3 16h18l-3-16"/><path d="M34 90h32"/>', '0 0 100 100'),
    typ_ipad: svg('<rect x="6" y="3" width="68" height="94" rx="6"/><circle cx="64" cy="12" r="3"/>', '0 0 80 100'),
  };
  const FARBE_HEX = { schwarz: '#1a1a1a', weiss: '#f2f2f0', silber: '#d6d6d6', gold: '#e3cfa8', graphit: '#4a4a4c', rosa: '#f3c7cc', tuerkis: '#9bd4cf', ultramarin: '#5f7cd8', nebelblau: '#b9cbe0', salbei: '#aebfa5', lavendel: '#c9bfe5', orange: '#f27a2f', dunkelblau: '#283a62', gletscher: '#dfe6ea', burgund: '#6f2432', pazifikblau: '#2d4b63', sierrablau: '#a7c1dc', alpengruen: '#576856', rot: '#c8102e', polarstern: '#f3efe6', mitternacht: '#1f2630', blau: '#4d6d9a', gruen: '#3f6b55', lila: '#cdbfe3', gelb: '#f2e27a' };

  // ---------- Speicher wie „Meine Geräte“ ----------
  const KEY = 'rxk-geraete', GAST = 'rxk-geraete-gast', AUS = 'rxk-geraete-aus';
  const lesen = (s, k) => { try { return JSON.parse(s.getItem(k)); } catch { return null; } };
  const istGast = () => !!lesen(sessionStorage, GAST);
  const merken = (m) => {
    const d = (istGast() ? lesen(sessionStorage, GAST) : lesen(localStorage, KEY)) || {};
    const z = { geraete: Array.isArray(d.geraete) ? d.geraete : [], aktiv: d.aktiv && typeof d.aktiv === 'object' ? d.aktiv : {} };
    if (!z.geraete.includes(m)) z.geraete.push(m);
    z.aktiv[gruppe(m)] = m;
    try { sessionStorage.removeItem(AUS); (istGast() ? sessionStorage : localStorage).setItem(istGast() ? GAST : KEY, JSON.stringify({ ...z, t: Date.now() })); } catch {}
  };
  const gruppe = (m) => (/^iPhone/i.test(m) ? 'iphone' : /^MacBook/i.test(m) ? 'mac' : /^iPad/i.test(m) ? 'ipad' : /^iMac/i.test(m) ? 'imac' : '');

  const el = (tag, cls, html) => { const e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
  const ta = document.createElement('textarea');
  const dekodieren = (s) => { ta.innerHTML = s; return ta.value; };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  class RxkGeraeteFinder extends HTMLElement {
    connectedCallback() {
      const d = JSON.parse(this.querySelector('[data-gf-daten]').textContent);
      this.t = d.texte;
      this.produkte = d.produkte || [];
      this.shop = d.shop;
      this.buehne = this.querySelector('[data-gf-buehne]');
      this.leiste = this.querySelector('[data-gf-leiste]');
      this.querySelector('[data-gf-zurueck]').addEventListener('click', () => this.zurueck());
      this.querySelector('[data-gf-neu]').addEventListener('click', () => this.start());
      this.verlauf = [];
      // Eingebettet (23.10.2026): im Gerätefenster bzw. als Schublade auf der Produktseite – Ergebnis meldet sich per Ereignis
      this.eingebettet = this.dataset.modus === 'eingebettet';
      // Rücksprung zur Produktseite (?zurueck=/products/…), nur eigene Shop-Pfade
      const z = new URLSearchParams(location.search).get('zurueck') || '';
      this.zurueck = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)\/[\w\-\/]*$/i.test(z) ? z : '';
      this.start();
    }

    // Shopifys t-Filter liefert die Texte HTML-kodiert (13&quot;) -> einmal zurück in Klartext, esc() kommt später
    tx(k, w) { let s = this.t[k] || k; if (w) for (const [a, b] of Object.entries(w)) s = s.replace(`__${a}__`, b); return dekodieren(s); }

    zeigen(name, bau) {
      this.verlauf.push({ name, bau });
      this.leiste.hidden = this.verlauf.length < 2;
      // Schrittzeile: Gerätetyp + aktueller Schritt (nicht der ganze Verlauf)
      const namen = this.verlauf.map((v) => v.name).filter(Boolean);
      this.querySelector('[data-gf-schritt]').textContent = [...new Set([namen[0], namen[namen.length - 1]])].filter(Boolean).join(' · ');
      this.buehne.replaceChildren();
      this.classList.remove('rxk-gf--fertig');
      this.classList.toggle('rxk-gf--laeuft', this.verlauf.length > 1);
      bau(this.buehne);
      // Fortschrittslinie unter der Leiste: Schritte zählen, Ergebnis = voll
      const f = this.querySelector('[data-gf-fortschritt]');
      if (f) f.style.width = (this.classList.contains('rxk-gf--fertig') ? 100 : Math.min(80, (this.verlauf.length - 1) * 25)) + '%';
      if (this.verlauf.length > 1) {
        if (this.eingebettet) { const d = this.closest('dialog'); if (d) d.scrollTop = 0; }
        else this.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
    zurueck() {
      this.verlauf.pop();
      const v = this.verlauf.pop();
      if (v) this.zeigen(v.name, v.bau); else this.start();
    }

    // Schritt 0: Gerätetyp
    start() {
      this.verlauf = [];
      this.zeigen('', (b) => {
        b.append(el('h2', 'rxk-gf__frage', esc(this.tx('typ_frage'))));
        const k = el('div', 'rxk-gf__kacheln rxk-gf__kacheln--3 rxk-gf__kacheln--4');
        for (const g of ['iphone', 'mac', 'ipad', 'imac']) k.append(this.kachel(BILD['typ_' + g], this.tx(g), '', () => this.modell(g)));
        b.append(k);
      });
    }

    // Am iPhone: Vorschlag aus der Bildschirmgröße
    vorschlag(b) {
      if (!/iPhone/.test(navigator.userAgent)) return;
      const w = Math.min(screen.width, screen.height), h = Math.max(screen.width, screen.height);
      const kand = (BILDSCHIRM[`${w}x${h}`] || []).map((n) => ALLE.find((d) => d.n === n)).filter(Boolean);
      if (!kand.length) return;
      const box = el('div', 'rxk-gf__vorschlag');
      box.append(el('p', '', esc(this.tx('screen_hint'))));
      const chips = el('div', 'rxk-gf__chips');
      for (const d of kand) { const c = el('button', 'rxk-gf__chip', esc(d.n)); c.type = 'button'; c.addEventListener('click', () => this.ergebnis([d], 'iphone')); chips.append(c); }
      box.append(chips);
      b.append(box);
    }

    kachel(bild, titel, hinweis, klick) {
      const k = el('button', 'rxk-gf__kachel');
      k.type = 'button';
      k.innerHTML = `<span class="rxk-gf__kachel-bild">${bild || ''}</span><span class="rxk-gf__kachel-text"><strong>${esc(titel)}</strong>${hinweis ? `<small>${esc(hinweis)}</small>` : ''}</span>`;
      k.addEventListener('click', klick);
      return k;
    }

    // Schritt 1: Modell wählen – ein Bildschirm: Liste, kurze Anleitung, Modellnummer, Aussehen-Hilfe
    modell(g) {
      this.g = g;
      this.zeigen(this.tx(g), (b) => {
        b.append(el('h2', 'rxk-gf__frage', esc(this.tx('wahl_' + g))));
        if (g === 'iphone') this.vorschlag(b);
        // Kurze Anleitung in einer Zeile
        const hilfe = el('div', 'rxk-gf__hilfe');
        hilfe.append(el('strong', '', esc(this.tx('unsicher'))), el('span', '', esc(this.tx('kurz_' + g))));
        b.append(hilfe);
        // Modellreihen
        const liste = el('div', 'rxk-gf__liste');
        const reihe = (titel, eintraege) => {
          const r = el('div', 'rxk-gf__reihe');
          r.append(el('h3', 'rxk-gf__reihe-titel', esc(titel)));
          const chips = el('div', 'rxk-gf__chips');
          for (const [d, text, klein] of eintraege) { const c = el('button', 'rxk-gf__chip', esc(text) + (klein ? ` <small>${esc(klein)}</small>` : '')); c.type = 'button'; c.addEventListener('click', () => this.ergebnis([d], g)); chips.append(c); }
          r.append(chips);
          liste.append(r);
        };
        if (g === 'imac') {
          for (const c of ['M6', 'M4', 'M3', 'M1']) {
            const d = IMAC.filter((m) => m.c === c);
            reihe(`iMac 24" (${c}) · ${d[0].j}`, d.map((m) => [m, `${m.u} × USB-C`, '']));
          }
        } else if (g === 'mac') {
          for (const t of ['Neo', 'Air', 'Pro']) for (const z of [13, 14, 15, 16]) {
            const d = MAC.filter((m) => m.t === t && m.z === z);
            if (d.length) reihe(`MacBook ${t} ${z}"`, d.map((m) => [m, m.c, String(m.j)]));
          }
        } else {
          const daten = ALLE.filter((d) => d.g === g && !d.nv);
          const gruppen = new Map();
          for (const d of daten) { const k = g === 'ipad' ? d.t : String(d.j); if (!gruppen.has(k)) gruppen.set(k, []); gruppen.get(k).push(d); }
          const reihen = [...gruppen.entries()];
          if (g === 'iphone') reihen.reverse();
          for (const [k, d] of reihen) reihe(g === 'ipad' ? (k === 'iPad' ? 'iPad' : 'iPad ' + k) : k, d.map((m) => [m, m.e || m.n, m.e ? m.n : '']));
        }
        b.append(liste);
        // Modellnummer direkt hier
        const nr = el('div', 'rxk-gf__nummer');
        nr.append(el('h3', 'rxk-gf__nummer-titel', esc(this.tx('oder_nummer'))));
        nr.append(el('p', 'rxk-gf__hinweis', esc(this.tx('a_wo_' + g))));
        const zeile = el('div', 'rxk-gf__eingabe');
        const inp = el('input');
        inp.type = 'text'; inp.inputMode = 'text'; inp.autocapitalize = 'characters'; inp.placeholder = this.tx('a_platz'); inp.setAttribute('aria-label', this.tx('oder_nummer'));
        const aus = el('div', 'rxk-gf__treffer');
        inp.addEventListener('input', () => {
          const v = inp.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          aus.replaceChildren();
          if (v.length < 4) return;
          const tr = ALLE.filter((d) => d.a.some((a) => a === v || a.startsWith(v)));
          if (!tr.length) { aus.append(el('p', 'rxk-gf__leer', esc(this.tx('a_keine')))); return; }
          const genau = tr.filter((d) => d.a.includes(v));
          if (genau.length) { this.ergebnis(genau, g); return; }
          for (const d of tr.slice(0, 8)) { const c = el('button', 'rxk-gf__chip', `${esc(d.n)} <small>${d.a.filter((a) => a.startsWith(v)).join(', ')}</small>`); c.type = 'button'; c.addEventListener('click', () => this.ergebnis([d], g)); aus.append(c); }
        });
        zeile.append(inp);
        nr.append(zeile, aus);
        b.append(nr);
        // iPhone: Aussehen-Fragen als Ausweg
        if (g === 'iphone') { const w = el('button', 'rxk-gf__aussehen', esc(this.tx('aussehen_link'))); w.type = 'button'; w.addEventListener('click', () => this.aussehen()); b.append(w); }
      });
    }

    // Weg S: Aussehen (nur iPhone)
    aussehen() {
      this.kand = IPHONE.filter((d) => d.k);
      this.frageNr = 0;
      this.naechsteFrage();
    }
    naechsteFrage() {
      const kand = this.kand;
      const frage = FRAGEN.slice(this.frageNr).find((f) => kand.every((d) => d[f.a] != null) && new Set(kand.flatMap((d) => [].concat(d[f.a]))).size > 1);
      if (!frage || kand.length <= 1) return this.ergebnis(kand, 'iphone');
      const n = FRAGEN.indexOf(frage) + 1;
      this.zeigen(this.tx('weg_s') + ' ' + n, (b) => {
        // Stand im Aufbau setzen, damit „Zurück“ (Neuaufbau) wieder von hier weiterfragt
        this.kand = kand;
        this.frageNr = n;
        b.append(el('h2', 'rxk-gf__frage', esc(this.tx('q_' + frage.a))));
        const k = el('div', 'rxk-gf__kacheln' + (frage.a === 'f' ? ' rxk-gf__kacheln--farben' : ''));
        const da = frage.werte.filter((w) => kand.some((d) => [].concat(d[frage.a]).includes(w)));
        for (const w of da) {
          const schl = frage.a + '_' + w;
          const bild = frage.a === 'f' ? `<i class="rxk-gf__farbe" style="--c:${FARBE_HEX[w] || '#ccc'}"></i>` : BILD[schl] || '';
          k.append(this.kachel(bild, this.tx(schl), this.t[schl + '_hinweis'] ? this.tx(schl + '_hinweis') : '', () => {
            this.kand = kand.filter((d) => [].concat(d[frage.a]).includes(w));
            this.naechsteFrage();
          }));
        }
        if (frage.a === 'k') k.append(this.kachel(BILD.k_aelter, this.tx('k_aelter'), this.tx('k_aelter_hinweis'), () => this.modell('iphone')));
        if (frage.a === 'f') k.append(this.kachel('<i class="rxk-gf__farbe rxk-gf__farbe--frage"></i>', this.tx('f_unsicher'), '', () => this.ergebnis(kand, 'iphone')));
        b.append(k);
      });
    }

    // Ergebnis: ein Gerät (gemerkt) oder mehrere Kandidaten (zur Wahl)
    ergebnis(kand, g) {
      const eins = kand.length === 1 ? kand[0] : null;
      if (eins && !eins.nv) merken(eins.n);
      if (this.eingebettet && eins && !eins.nv) { this.dispatchEvent(new CustomEvent('rxk-gf:gewaehlt', { bubbles: true, detail: { modell: eins.n } })); return; }
      this.zeigen(this.tx('ergebnis'), (b) => {
        this.classList.add('rxk-gf--fertig');
        b.append(el('p', 'rxk-st__marke', esc(this.tx(eins ? 'ergebnis' : 'ergebnis_mehr'))));
        if (!eins) b.append(el('p', 'rxk-gf__hinweis', esc(this.tx('ergebnis_hinweis_' + g))));
        const liste = el('div', 'rxk-gf__ergebnisse' + (eins ? '' : ' rxk-gf__ergebnisse--mehr'));
        for (const d of kand) {
          const karte = el('article', 'rxk-gf__karte');
          // Kopf: dunkles Panel mit Name, Jahr, A-Nummern und Strichzeichnung des Geräts
          const kopf = el('div', 'rxk-gf__karte-kopf');
          const text = el('div');
          text.append(el('h2', 'rxk-gf__name', esc(d.n)));
          text.append(el('p', 'rxk-gf__jahr', esc(String(d.j)) + (d.a.length ? ` · ${d.a.join(' · ')}` : '')));
          if (eins && !d.nv) text.append(el('p', 'rxk-gf__gemerkt', esc(this.tx('gemerkt'))));
          const bild = g === 'iphone' && d.k ? BILD['k_' + d.k] : BILD['typ_' + g];
          kopf.append(text, el('div', 'rxk-gf__karte-bild', bild || ''));
          karte.append(kopf);
          const rumpf = el('div', 'rxk-gf__karte-rumpf');
          if (eins) {
            this.produktliste(rumpf, d);
            if (this.zurueck && !d.nv) { const r = el('a', 'rxk-gf__zurueck-zu', esc(this.tx('zurueck_zu'))); r.href = this.zurueck; rumpf.append(r); }
          } else { const w = el('button', 'rxk-gf__weiter', esc(this.tx('das_ist_meins'))); w.type = 'button'; w.addEventListener('click', () => this.ergebnis([d], g)); rumpf.append(w); }
          karte.append(rumpf);
          liste.append(karte);
        }
        b.append(liste);
      });
    }

    produktliste(karte, d) {
      if (d.nv) { karte.append(el('p', 'rxk-gf__hinweis', esc(this.tx('keine_produkte')) + ` <a href="${esc(this.shop.kontakt)}">${esc(this.tx('schreib'))}</a>`)); return; }
      const passend = this.produkte.filter((p) => p.m.includes(d.n));
      if (!passend.length) { karte.append(el('p', 'rxk-gf__hinweis', esc(this.tx('keine_produkte')) + ` <a href="${esc(this.shop.kontakt)}">${esc(this.tx('schreib'))}</a>`)); return; }
      karte.append(el('h3', 'rxk-gf__reihe-titel', esc(this.tx('produkte', { N: passend.length }))));
      const raster = el('div', 'rxk-gf__produkte');
      for (const p of passend) {
        const a = el('a', 'rxk-gf__produkt');
        a.href = p.u;
        a.innerHTML = `<span class="rxk-gf__produkt-bild">${p.b ? `<img src="${esc(p.b)}" alt="" loading="lazy">` : ''}</span><span class="rxk-gf__produkt-titel">${esc(p.t)}</span>`;
        raster.append(a);
      }
      karte.append(raster);
      const alle = el('a', 'rxk-gf__shop', esc(this.tx('shop_link', { G: d.n })));
      alle.href = this.shop.alle;
      karte.append(alle);
    }
  }
  customElements.define('rxk-geraete-finder', RxkGeraeteFinder);
})();
